import { createContext, useContext } from 'react';

type AnonymousSessionContext = {
  clearSession: () => void;
};

const noOp = () => {};

const AnonymousSessionCtx = createContext<AnonymousSessionContext>({
  clearSession: noOp,
});

export const AnonymousSessionProvider = AnonymousSessionCtx.Provider;
export const useAnonymousSessionContext = () => useContext(AnonymousSessionCtx);
